module.exports = __webpack_public_path__ + "media/images/landing/illust/create-campaing-77ba7ada37ccb67a5c767676cd57f011.png";